import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function PartOrderFigures({partOrderData, partOrdersLoaded, totalProfit}){

    const colour = () => {
        if(totalProfit > 0){
            return "table-highlight-green-black-text"
        }
        else if(totalProfit < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }


    if(!partOrdersLoaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <Title>Part Orders</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Part Order Cost</th>
                                <th>Total Part Order Customer Charge</th>
                                <th>Total Part Order Profit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{partOrderData.total_part_order_cost}</td>
                                <td>{partOrderData.total_part_order_customer_cost}</td>
                                <td className={colour()}>{totalProfit}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );

}